export default function IconShiledCheck({ color = "white", size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 1}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M15 20L18.3333 23.3334L25 16.6667M34.3632 9.9739C34.0221 9.9912 33.6787 9.99995 33.3333 9.99995C28.2109 9.99995 23.5383 8.07422 19.9999 4.90723C16.4615 8.0741 11.789 9.99975 6.66667 9.99975C6.32129 9.99975 5.97796 9.99099 5.63688 9.9737C5.22117 11.5797 5 13.264 5 15C5 24.3192 11.3739 32.1497 20 34.3699C28.6261 32.1497 35 24.3192 35 15C35 13.2641 34.7788 11.5799 34.3632 9.9739Z"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
}
